import React, { useContext, useEffect, useState, useMemo } from 'react'
import * as classes from './Menu.module.scss'
import cn from 'classnames'
import Social from '../Social/Social'
import { FormContext } from '../../../context/index'
import { Link, navigate } from 'gatsby'
import { useDataHeaderByHy } from '../Header/useDataHeaderByHy'
import { useDataHeaderByEn } from '../Header/useDataHeaderByEn'
import { deleteHtmlTag } from '../../../utils/deleteHtmlTag'
import ukFlag from '../../../images/flags/uk.png'
import amFlag from '../../../images/flags/am.png'

function Menu({ lang, className }) {
    const menyByHY = useDataHeaderByHy()
    const menyByEN = useDataHeaderByEn()
    const menuData = lang === 'hy' ? menyByHY : menyByEN
    const menuLinks = menuData.menu.nodes
    const textButtonContactUs = useMemo(() => deleteHtmlTag(menuData.contactUs?.value ?? '', 'p'), [])
    const textLangEn = useMemo(() => deleteHtmlTag(menuData.languageEn?.value ?? 'Eng', 'p'), [])
    const textLangHy = useMemo(() => deleteHtmlTag(menuData.languageHy?.value ?? 'Հայ', 'p'), [])
    const flagEn = menuData.languageEn?.flag?.url || ukFlag
    const flagHy = menuData.languageHy?.flag?.url || amFlag
    const hrefContacts = lang === 'hy' ? '/contacts/' : '/en/contacts/'

    const menu = useMemo(
        () =>
            menuLinks.map((item) => {
                const innerLinks = menuLinks.filter((itemParent) => itemParent?.parentSection?.title === item.title)

                return { ...item, innerLinks }
            }),
        []
    )

    const menuResult = useMemo(() => menu.filter(({ parentSection }) => !parentSection), [])

    const { onCloseModal } = useContext(FormContext)
    const [isHomePage, setIsHomePage] = useState(true)
    const [activeIndex, setActiveIndex] = useState(null)

    const handlerOnClick = (e, item, index) => {
        if (item.innerLinks.length) {
            e.preventDefault()
            setActiveIndex((prev) => (prev === index ? null : index))
            return
        }

        onCloseModal()
    }

    const onGoToNewLanguageUrl = () => {
        let newUrl = ''

        if (lang === 'en') {
            newUrl = window.location.pathname.substring(3).trim()
            navigate(`${newUrl}`)
        } else {
            newUrl = window.location.pathname
            navigate(`/en${newUrl}`)
        }
    }

    const onSelectLanguage = (selectedLang) => {
        onCloseModal()

        if (selectedLang !== lang) {
            onGoToNewLanguageUrl()
        }
    }

    const onClickContactUs = () => {
        onCloseModal()
        navigate(hrefContacts)
    }

    useEffect(() => {
        const isHome = window.location.pathname === '/' || window.location.pathname === '/en/'
        setIsHomePage(isHome)
    }, [])

    return (
        <div className={cn(classes.Wrapper, classes[className])}>
            <div className={classes.Inner}>
                <div className={classes.Top}>
                    <div className={classes.LangSwitch}>
                        <button
                            type='button'
                            className={cn(classes.LangOption, { [classes.LangOptionActive]: lang === 'en' })}
                            onClick={() => onSelectLanguage('en')}
                        >
                            <img className={classes.FlagIcon} src={flagEn} alt='' />
                            {textLangEn}
                        </button>

                        <button
                            type='button'
                            className={cn(classes.LangOption, { [classes.LangOptionActive]: lang === 'hy' })}
                            onClick={() => onSelectLanguage('hy')}
                        >
                            <img className={classes.FlagIcon} src={flagHy} alt='' />
                            {textLangHy}
                        </button>
                    </div>

                    <div className={classes.Divider} />

                    <div className={classes.Body}>
                        <ul className={classes.Links}>
                            {menuResult
                                .filter((navItem) => !navItem?.url?.includes('contacts'))
                                .map((item, mainIndex) => (
                                <li className={cn(classes.LinkItem, { [classes.NoActive]: !isHomePage })} key={mainIndex}>
                                    <Link
                                        className={classes.LinkTitle}
                                        activeClassName={classes.Active}
                                        to={`${item.url}`}
                                        onClick={(e) => {
                                            handlerOnClick(e, item, mainIndex)
                                        }}
                                        partiallyActive={true}
                                    >
                                        <span className={classes.LinkTitleText}>{item.title}</span>

                                        {item.innerLinks.length ? (
                                            <span className={cn(classes.Chevron, { [classes.ChevronOpen]: activeIndex === mainIndex })} />
                                        ) : null}
                                    </Link>

                                    {item.innerLinks.length ? (
                                        <div className={cn(classes.InnerLinks, { [classes.Open]: activeIndex === mainIndex })}>
                                            {item.innerLinks.map((item, index) => (
                                                <Link
                                                    key={index}
                                                    activeClassName={classes.Active}
                                                    to={`${item.url}`}
                                                    onClick={() => {
                                                        onCloseModal()
                                                    }}
                                                    partiallyActive={true}
                                                >
                                                    {item.title}
                                                </Link>
                                            ))}
                                        </div>
                                    ) : null}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className={classes.Footer}>
                    <button type='button' className={classes.ContactUs} onClick={onClickContactUs}>
                        {textButtonContactUs}
                    </button>

                    <Social
                        className={classes.Social}
                        fb={{
                            url: menuData?.fb.url,
                            sizes: {
                                width: 24,
                                height: 24
                            },
                            styles: {
                                bgColor: '#FFFFFF'
                            }
                        }}
                        linkedin={{
                            url: menuData?.linkedin.url,
                            sizes: {
                                width: 24,
                                height: 24
                            },
                            styles: {
                                bgColor: '#FFFFFF'
                            }
                        }}
                        inst={{
                            url: menuData?.inst.url,
                            sizes: {
                                width: 24,
                                height: 24
                            },
                            styles: {
                                bgColor: '#FFFFFF'
                            }
                        }}
                        youTube={{
                            url: menuData?.YouTube.url,
                            sizes: {
                                width: 24,
                                height: 24
                            },
                            styles: {
                                bgColor: '#FFFFFF'
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default Menu
